import { render, staticRenderFns } from "./NewPasswordModal.vue?vue&type=template&id=98cab99c&scoped=true"
import script from "./NewPasswordModal.vue?vue&type=script&lang=js"
export * from "./NewPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./NewPasswordModal.vue?vue&type=style&index=0&id=98cab99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cab99c",
  null
  
)

export default component.exports